/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { spacing } from '../../../shared/theme/spacing';
import { ticketColors } from '../../../shared/theme/ticketColors';
import type { SettingsNavTone } from '../../../settings/components/SettingsNavigationRow';
import { BranchCashStatusPill } from './BranchCashStatusPill';

type Props = {
  title: string;
  description: string;
  cashOpen: boolean | null;
  onPress: () => void;
  tone?: SettingsNavTone;
  testID?: string;
};

export function BranchSelectionRow({
  title,
  description,
  cashOpen,
  onPress,
  tone = 'default',
  testID,
}: Props) {
  const titleColor =
    tone === 'danger' ? ticketColors.bad : tone === 'accent' ? ticketColors.gold : ticketColors.ink;
  const chevronColor =
    tone === 'danger' ? ticketColors.bad : tone === 'accent' ? ticketColors.gold : ticketColors.ink2;

  const cashLabel =
    cashOpen === null ? null : cashOpen ? 'Caja abierta' : 'Caja cerrada';
  const accessibilityLabel = [title, description, cashLabel].filter(Boolean).join('. ');

  return (
    <TouchableOpacity
      onPress={onPress}
      activeOpacity={0.85}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel}
      testID={testID}
    >
      <View style={localStyles.card}>
        <View style={localStyles.row}>
          <View style={localStyles.body}>
            <Text style={[localStyles.title, { color: titleColor }]} numberOfLines={1}>
              {title}
            </Text>
            <Text style={localStyles.description} numberOfLines={1}>
              {description}
            </Text>
          </View>
          <View style={localStyles.trailing}>
            {cashOpen !== null ? <BranchCashStatusPill cashOpen={cashOpen} /> : null}
            <Text style={[localStyles.chevron, { color: chevronColor }]}>›</Text>
          </View>
        </View>
      </View>
    </TouchableOpacity>
  );
}

const localStyles = StyleSheet.create({
  card: {
    backgroundColor: ticketColors.paper2,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    paddingVertical: 12,
    paddingHorizontal: 14,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.sm,
  },
  body: {
    flex: 1,
    minWidth: 0,
    gap: 4,
  },
  title: {
    fontSize: 15,
    fontWeight: '600',
    color: ticketColors.ink,
  },
  description: {
    fontSize: 13,
    color: ticketColors.ink3,
    lineHeight: 18,
  },
  trailing: {
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: 6,
    flexShrink: 0,
  },
  chevron: {
    fontSize: 20,
    lineHeight: 20,
    fontWeight: '400',
  },
});
